<p-dialog header="{{'Confirm' | translate}}" [(visible)]="displayConfirmDialog" [modal]="true" [style]="{'width': '450px'}"
          class="ConfirmDialog">
  <div class="page-content-body">
    <p translate>Do you really want to delete this Group?</p>
  </div>
  <ng-template #footer>
    <div class="page-content-btn">
      <button type="button" pButton label="{{'Confirm' | translate}}" class="{{Confirm_button}}" (click)="saveDeleteGroup()"></button>
      <button type="button" pButton (click)="displayConfirmDialog=false" label="{{'Cancel' | translate}}"
              class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog>
